var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1062_44882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 14.5H18.0001C15.8004 14.5 14.0002 16.3002 14.0002 18.4999V26.5001C14.0002 28.6993 15.8004 30.5 18.0001 30.5H26C28.1997 30.5 29.9999 28.6993 29.9999 26.5001V18.4999C29.9999 16.3002 28.1997 14.5 26 14.5ZM28.6665 26.5001C28.6665 27.9701 27.4707 29.1666 26 29.1666H18.0001C16.53 29.1666 15.3336 27.9701 15.3336 26.5001V18.4999C15.3336 17.0295 16.53 15.8334 18.0001 15.8334H26C27.4707 15.8334 28.6665 17.0295 28.6665 18.4999V26.5001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.334 19.1665C26.8862 19.1665 27.3339 18.7188 27.3339 18.1665C27.3339 17.6142 26.8862 17.1665 26.334 17.1665C25.7817 17.1665 25.334 17.6142 25.334 18.1665C25.334 18.7188 25.7817 19.1665 26.334 19.1665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 18.5C19.7903 18.5 18 20.2905 18 22.4999C18 24.7084 19.7903 26.5002 21.9999 26.5002C24.2088 26.5002 25.9998 24.7084 25.9998 22.4999C25.9998 20.2905 24.2088 18.5 21.9999 18.5ZM21.9999 25.1668C20.5273 25.1668 19.3334 23.9729 19.3334 22.4999C19.3334 21.0269 20.5273 19.8334 21.9999 19.8334C23.4725 19.8334 24.6664 21.0269 24.6664 22.4999C24.6664 23.9729 23.4725 25.1668 21.9999 25.1668Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 43,
    height: 43,
    rx: 11.5,
    stroke: "#E2E4E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1062_44882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(14 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8fdd3a922fa2b993bf7398ecc0feba30.svg";
export { ForwardRef as ReactComponent };